import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import styles from './ReviewedHairstylistCard.module.css';
import ReviewModal from './ReviewModal';
import { useReviews } from '../hooks/useReviews';
import anonymousAvatar from '../assets/images/anonymous-avatar.svg';
import { getDisplayLocation } from '../utils/locationHelpers';

function ReviewedHairstylistCard({ stylist, review, serviceLookup = {} }) {
  const {
    id,
    name,
    profilePhoto,
  } = stylist;

  const navigate = useNavigate();
  const { deleteReview } = useReviews(id);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const avatarSrc = profilePhoto || anonymousAvatar;

  const handleCardClick = () => {
    navigate(`/hairstylist/${id}`);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('fr-FR', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    setShowReviewModal(true);
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    if (window.confirm('Êtes-vous sûr de vouloir supprimer votre avis ?')) {
      setDeleting(true);
      try {
        await deleteReview();
        window.location.reload(); // Recharger la page pour afficher les changements
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error deleting review:', error);
        alert('Erreur lors de la suppression de l\'avis');
      } finally {
        setDeleting(false);
      }
    }
  };

  return (
    <>
      <article className={styles.card} onClick={handleCardClick}>
        <div className={styles.cardRow}>
          {/* Colonne gauche : Photo + Nom + Localisation */}
          <div className={styles.profileColumn}>
            <div className={styles.avatarWrapper}>
              <img src={avatarSrc} alt={name} />
            </div>
            <div className={styles.profileInfo}>
              <div className={styles.name}>{name}</div>
              <div className={styles.city}>
                <svg viewBox="0 0 24 24" aria-hidden="true" className={styles.cityIcon}>
                  <path
                    d="M12 21s-6-5.148-6-10.5a6 6 0 1112 0C18 15.852 12 21 12 21z"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                  />
                  <circle cx="12" cy="10.5" r="1.7" fill="currentColor" />
                </svg>
                {getDisplayLocation(stylist)}
              </div>
            </div>
          </div>

          {/* Colonne droite : Détails de la review */}
          <div className={styles.reviewColumn}>
            <div className={styles.reviewHeader}>
              <div className={styles.rating}>
                {[...Array(5)].map((_, i) => (
                  <span 
                    key={i} 
                    className={i < review.rating ? styles.starFilled : styles.starEmpty}
                  >
                    ★
                  </span>
                ))}
                <span className={styles.ratingValue}>({review.rating}/5)</span>
              </div>
              <div className={styles.reviewDate}>
                {formatDate(review.createdAt)}
              </div>
            </div>
            
            {review.comment && (
              <div className={styles.reviewComment}>
                {review.comment}
              </div>
            )}

            {/* Boutons d'action */}
            <div className={styles.actionButtons}>
              <button
                type="button"
                className={styles.editBtn}
                onClick={handleEdit}
                disabled={deleting}
              >
                Modifier
              </button>
              <button
                type="button"
                className={styles.deleteBtn}
                onClick={handleDelete}
                disabled={deleting}
              >
                {deleting ? 'Suppression...' : 'Supprimer'}
              </button>
            </div>
          </div>
        </div>
      </article>
      {showReviewModal && (
        <ReviewModal
          hairstylistId={id}
          hairstylistName={name}
          existingReview={review}
          onClose={() => {
            setShowReviewModal(false);
            window.location.reload(); // Recharger pour afficher les modifications
          }}
        />
      )}
    </>
  );
}

export default ReviewedHairstylistCard;

